import { Box, Typography } from '@mui/material'
import React from 'react'
import { ChangeOrderProvider } from '../components/changeOrders/ChangeOrderContext'
import FilterHeader from '../components/changeOrders/FilterHeader'
import ChangeOrderList from '../components/changeOrders/ChangeOrderList'
import CreateChangeOrderButton from '../components/changeOrders/CreateChangeOrderButton'
import { useLocation } from 'react-router-dom'
export default function ChangeOrdersPage() {
	const location = useLocation()
	const {
		fromNotification,
		surveyId: fromNotificationSurveyId,
		key,
	} = (location.state as {
		surveyId: string
		fromNotification: boolean
		searchWi: string
		key: number
	}) || {}
	return (
		<div className='page-layout'>
			<ChangeOrderProvider
				initialSurveyId={fromNotificationSurveyId ? parseInt(fromNotificationSurveyId) : null}
				key={key}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						width: '100%',
						paddingLeft: '1rem',
						paddingRight: '1rem',
						paddingTop: '.5rem',
						zIndex: '3',
					}}
				>
					<Typography
						sx={{
							fontSize: '1.5rem',
						}}
					>
						Change Orders
					</Typography>
					<CreateChangeOrderButton />
				</Box>


				<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2, mx: 2 }}>
					<FilterHeader />
					<ChangeOrderList />
				</Box>
			</ChangeOrderProvider>
		</div>
	)
}
